import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-row mr-auto" }
const _hoisted_3 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_4 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8" }
const _hoisted_8 = { class: "py-6" }
const _hoisted_9 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_10 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_11 = { class: "px-8 py-4 uppercase" }
const _hoisted_12 = { class: "mt-3 flex row justify-around" }
const _hoisted_13 = { class: "px-8 py-4 uppercase" }
const _hoisted_14 = { class: "mt-3 flex row justify-around" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import { SearchIcon } from "@heroicons/vue/solid";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateSelector from "@/components/tools/DateTimeSelector.vue";
import PlayerFilterDialog from "@/components/dialogs/PlayerFilterDialog.vue";
import CreatePlayerDialog from "@/components/dialogs/CreatePlayerDialog.vue";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import { translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListV2',
  setup(__props) {

dayjs.extend(localizedFormat);
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const router = useRouter(); //////////////////////////////////////////////////
const dataRows = ref([]);
const isLoaded = ref(false);
const searchInput = ref();
const advanceFilterModal = ref(false);
const createPlayerModal = ref(false);
const isActivateUser = ref(false);
const isSuspend = ref(false);
const toSuspendData = ref();
const reason = ref("");
const columns = [
  {
    label: translate("messages.players.phoneNumber"),
    field: "phoneNumber",
    isIconFunction: true,
    format: (data: any) => data.username,
    auxClick: (data: any) => window.open(`/players/${data.id}`),
    // router.push({ name: "Wallet Info", params: { id: data.id } }),
    function: (data: any) =>
      router.push({ name: "Wallet Info", params: { id: data.id } }),
  },
  {
    label: translate("messages.players.bankAccountName"),
    field: "username",
    format: (data: any) => data.userBankAccounts.accountNameTh,
  },
  {
    label: translate("messages.players.bankAccountNumber"),
    field: "username",
    format: (data: any) => data.userBankAccounts.accountNumber,
  },
  {
    label: translate("messages.players.ipAddress"),
    format: (data: any) => data.lastLoginIp,
  },
  {
    label: translate("messages.players.activeStatus"),
    isIconActive: true,
    align: "center",
    format: (data: any) => data.isActive,
  },
  {
    label: translate("messages.players.date"),
    field: "createdAt",
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: translate("messages.players.currentBalance"),
    field: "balance",
    format: (data: any) =>
      Number(data.balance / 100).toLocaleString("en", {
        useGrouping: true,
        minimumFractionDigits: 2,
      }),
  },
  {
    label: translate("messages.players.action"),
    field: "action",
    align: "center",
    isToggle: true,
    function: (data: any) => {
      if (data.isActive) {
        isSuspend.value = !isSuspend.value;
      }
      if (!data.isActive) {
        isActivateUser.value = !isActivateUser.value;
      }
      toSuspendData.value = data;
    },
    permission: "USER.UPDATE_STATUS",
  },
];

const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  sort: [["createdAt", "DESC"]],
});

const filterForm = ref<{
  phoneNumber: string | undefined;
  ipAddress: string | undefined;
  bankAccountNum: string | undefined;
  bankAccount: string | undefined;
  username?: string | undefined;
  createdAt: string | undefined;
}>({
  phoneNumber: undefined,
  ipAddress: undefined,
  bankAccountNum: undefined,
  bankAccount: undefined,
  username: undefined,
  createdAt: undefined,
});

const filterModal = (
  data = {
    flag: 0,
    phoneNumber: null,
    ipAddress: null,
    bankAccountNum: null,
    bankAccount: null,
    createdAt: null,
  }
) => {
  advanceFilterModal.value = !advanceFilterModal.value;

  if (data.flag == 1) {
    pageConfig.value.page = 1;
    filterForm.value.phoneNumber = data.phoneNumber
      ? data.phoneNumber
      : undefined;
    filterForm.value.ipAddress = data.ipAddress ? data.ipAddress : undefined;
    filterForm.value.bankAccountNum = data.bankAccountNum
      ? data.bankAccountNum
      : undefined;
    filterForm.value.bankAccount = data.bankAccount
      ? data.bankAccount
      : undefined;
    filterForm.value.createdAt = data.createdAt ? data.createdAt : undefined;

    delete filterForm.value.username;

    fetchPageData();
  }
};

const doSort = (attName: string) => {
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  if (attName === "Date") attName = "createdAt";
  sort[0] = [attName.toLowerCase(), mode === "DESC" ? "ASC" : "DESC"];

  fetchPageData();
};

const onSuspendUser = async (suspendUserId: string) => {
  try {
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/user-status/suspend`,
      {
        operatorId: store.state.selectedOperator.operatorId,
        userId: suspendUserId,
        adminId: store.state.user.id,
        notes: reason.value || ""
      }
    );
  } catch (e) {
    alert('Permissions access denied')
    isSuspend.value = false
  }
  isSuspend.value = false;

  fetchPageData();
};
const onActiveUser = async (activateUserId: string) => {
  try {
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/user-status/activate`,
      {
        operatorId: store.state.selectedOperator.operatorId,
        userId: activateUserId,
        adminId: store.state.user.id,
      }
    );
  } catch (e) {
    alert('Permissions access denied')
    isSuspend.value = false
  }

  isActivateUser.value = false;
  fetchPageData();
};

const search = async (e: any, query?: string) => {
  if ((e.code == "Enter" || e.code == "NumpadEnter" || e.keyCode == 13) && isLoaded.value === true) {
    isLoaded.value = false
    if (query) filterForm.value.username = query;
    else filterForm.value.username = searchInput.value;
    await fetchPageData();
    isLoaded.value = true
  }
};

const fetchPageData = async () => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort } = pageConfig.value;

  const payload: any = {
    operatorId: store.state.selectedOperator.operatorId,
    filter: {
      username: filterForm.value.username,
    },
    advanceFilter: {
      phoneNumber: filterForm.value.phoneNumber
        ? filterForm.value.phoneNumber.replace("0", "+66")
        : null,
      ipAddress: filterForm.value.ipAddress,
      createdAt: filterForm.value.createdAt,
      bankAccountNum: filterForm.value.bankAccountNum,
      bankAccount: filterForm.value.bankAccount,
    },
    page: page - 1,
    pageSize: rowsPerPage,
    sortBy: sort.map((x) => [x[0], x[1] == "DESC" ? -1 : 1]),
  };

  if (filterForm.value.username) delete payload["advanceFilter"];
  else delete payload["filter"];

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/cms/user/list-pagination`;
  const { data } = await axios
    .post(url, payload)
    .then(({ data }) => data.result);

  // if(!data || data.length == 0){
  //   if(page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }
  pageConfig.value.dataLength = data.length;

  dataRows.value = Array.isArray(data as any) ? data : [data];
  if (
    (filterForm.value.phoneNumber ||
      filterForm.value.bankAccountNum ||
      filterForm.value.bankAccount ||
      filterForm.value.ipAddress ||
      filterForm.value.username ||
      searchInput.value) &&
    dataRows.value.length == 1
  ) {
    router.push({
      name: "Wallet Info",
      params: { id: (dataRows.value[0] as any).id },
    });
    return;
  }

  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */

  window.history.replaceState(
    {},
    document.title,
    `players?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};

const onSearch = (payload: { from: null; to: null }) => {
  fetchPageData();
};

onMounted(() => {
  if (route.query.username) {
    filterForm.value.username = route.query.username as string;
  }
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.players.players'),
        createPlayerButton: true,
        onOnClickCreatePlayer: _cache[0] || (_cache[0] = ($event: any) => (createPlayerModal.value = true))
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              type: "search",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchInput).value = $event)),
              name: "search",
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              placeholder: _ctx.$t('messages.players.search'),
              onKeyup: _cache[2] || (_cache[2] = ($event: any) => (search($event)))
            }, null, 40, _hoisted_5), [
              [_vModelText, searchInput.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createVNode(_component_font_awesome_icon, {
            class: "text-gray-500",
            icon: ['fas', 'circle-notch'],
            transform: "grow-6",
            spin: ""
          }, null, 512), [
            [_vShow, !isLoaded.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (filterModal())),
            class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "text-white mr-2",
              icon: ['far', 'filter'],
              transform: ""
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.players.advanceFilter")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(DataTable, {
              columns: columns,
              data: dataRows.value,
              onSort: doSort,
              isLoaded: isLoaded.value
            }, null, 8, ["data", "isLoaded"]),
            _createVNode(Pagination, {
              config: pageConfig.value,
              "onUpdate:config": _cache[4] || (_cache[4] = ($event: any) => ((pageConfig).value = $event))
            }, null, 8, ["config"])
          ])
        ])
      ])
    ]),
    _createVNode(PlayerFilterDialog, {
      class: "z-10",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[6] || (_cache[6] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"]),
    _createVNode(CreatePlayerDialog, {
      class: "z-10",
      show: createPlayerModal.value,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((createPlayerModal).value = $event)),
      onSubmit: _cache[8] || (_cache[8] = () => {
      createPlayerModal.value = false;
      fetchPageData();
    }
    ),
      onCancel: _cache[9] || (_cache[9] = () => {
        createPlayerModal.value = false;
        fetchPageData();
      }
      )
    }, null, 8, ["show"]),
    _createVNode(DialogComponent, {
      title: _ctx.$t('messages.players.confirmUserSespension'),
      isOpen: isSuspend.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.players.id")) + ": " + _toDisplayString(toSuspendData.value.id), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.players.username")) + ": " + _toDisplayString(toSuspendData.value.username), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.players.firstname")) + ": " + _toDisplayString(toSuspendData.value.firstName), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.players.phoneNumber")) + ": " + _toDisplayString(toSuspendData.value.phoneNumber), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(`messages.player.id.reason`)) + ": ", 1),
            _withDirectives(_createElementVNode("textarea", {
              class: "w-full rounded",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((reason).value = $event))
            }, null, 512), [
              [_vModelText, reason.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "bg-blue-500 uppercase rounded-lg text-white p-2",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (onSuspendUser(toSuspendData.value.id)))
          }, _toDisplayString(_ctx.$t("messages.players.confirm")), 1),
          _createElementVNode("button", {
            onClick: _cache[12] || (_cache[12] = () => {
          isSuspend.value = !isSuspend.value;
          fetchPageData();
        }
        ),
            class: "bg-red-600 rounded-lg uppercase text-white p-2"
          }, _toDisplayString(_ctx.$t("messages.players.cancel")), 1)
        ])
      ]),
      _: 1
    }, 8, ["title", "isOpen"]),
    _createVNode(DialogComponent, {
      title: _ctx.$t('messages.players.confirmActivation'),
      isOpen: isActivateUser.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.players.id")) + ": " + _toDisplayString(toSuspendData.value.id), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.players.username")) + ": " + _toDisplayString(toSuspendData.value.username), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.players.firstname")) + ": " + _toDisplayString(toSuspendData.value.firstName), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.players.phoneNumber")) + ": " + _toDisplayString(toSuspendData.value.phoneNumber), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "bg-blue-500 uppercase rounded-lg text-white p-2",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (onActiveUser(toSuspendData.value.id)))
          }, _toDisplayString(_ctx.$t("messages.players.confirm")), 1),
          _createElementVNode("button", {
            class: "bg-red-600 rounded-lg uppercase text-white p-2",
            onClick: _cache[14] || (_cache[14] = () => {
          isActivateUser.value = !isActivateUser.value;
          fetchPageData();
        }
        )
          }, _toDisplayString(_ctx.$t("messages.players.cancel")), 1)
        ])
      ]),
      _: 1
    }, 8, ["title", "isOpen"])
  ], 64))
}
}

})